import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UpcomingAssignments, CalendarDayIcon } from '../../components';
import { EventApi } from '../../services/ApiService';

export default function MobileEventAssignmentsPage(){
  const { eventId } = useParams();
  const [event,setEvent]=useState(null);
  const [loading,setLoading]=useState(true);
  const [err,setErr]=useState(null);

  useEffect(()=>{
    let active = true;
    (async()=>{
      try{
        setLoading(true);
        const res = await EventApi.getEvent(eventId);
        if(!res.ok) throw new Error('Failed to load event');
        const data = await res.json();
        if(active) setEvent(data);
      }catch(e){
        if(active) setErr(e.message || 'Error');
      }finally{
        if(active) setLoading(false);
      }
    })();
    return ()=>{active=false;};
  },[eventId]);

  if(loading) return <div className="m-screen"><p>Loading...</p></div>;
  if(err) return <div className="m-screen"><p>Error: {err}</p></div>;
  if(!event) return <div className="m-screen"><p>Event not found.</p></div>;

  return (
    <div className="m-screen single-card-screen">
      <h2 className="m-subtitle m-subtitle-with-icon">
        <CalendarDayIcon date={event.startDatetime || event.eventDate || new Date()} size={24} />
        <span>Event Assignments</span>
      </h2>
      <UpcomingAssignments
        courseEndeavorId={event.endeavorId}
        courseName={event.endeavorName}
        eventId={eventId}
        defaultStatus="all"
        defaultDue="all"
      />
    </div>
  );
}